import z from "zod";

import { sizeAttributeSchema } from "@frontend/bridge/sizeSchema";
import { SIZES } from "@frontend/styles/constants";

export const iconDataSchema = z.object({
  name: z.string().describe("Lucide icon name."),
  size: sizeAttributeSchema(SIZES).optional(),
});

export type IconDataProps = z.infer<typeof iconDataSchema>;
